import { render, staticRenderFns } from "./matomo-tracker.vue?vue&type=template&id=f78c460e&scoped=true&lang=pug&"
var script = {}
import style0 from "./matomo-tracker.vue?vue&type=style&index=0&id=f78c460e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78c460e",
  null
  
)

export default component.exports